import { clsx } from 'clsx'

import { NowButton, PeriodSelector, TimeGrid } from './TimeGrid'
import { generateHours, generateMinutes } from './utils'

interface DesktopDropdownProps {
  format: '12' | '24'
  minuteStep: number
  selectedHour: number | null
  selectedMinute: number | null
  selectedPeriod: 'AM' | 'PM'
  onHourSelect: (hour: number) => void
  onMinuteSelect: (minute: number) => void
  onPeriodSelect: (period: 'AM' | 'PM') => void
  onNowClick: () => void
}

export function DesktopDropdown({
  format,
  minuteStep,
  selectedHour,
  selectedMinute,
  selectedPeriod,
  onHourSelect,
  onMinuteSelect,
  onPeriodSelect,
  onNowClick,
}: DesktopDropdownProps): JSX.Element {
  return (
    <div
      aria-label="Select time"
      className={clsx(
        'absolute z-50 mt-1 p-3',
        'bg-card',
        'border border-border',
        'rounded-lg shadow-lg',
        'animate-scale-in',
        'w-[268px]'
      )}
      role="dialog"
    >
      <TimeGrid
        gridCols="grid-cols-6"
        items={generateHours(format)}
        label="Hour"
        selectedItem={selectedHour}
        onSelect={onHourSelect}
      />
      <TimeGrid
        gridCols="grid-cols-6"
        items={generateMinutes(minuteStep)}
        label="Minute"
        selectedItem={selectedMinute}
        onSelect={onMinuteSelect}
      />
      {format === '12' && (
        <PeriodSelector selectedPeriod={selectedPeriod} onSelect={onPeriodSelect} />
      )}
      <NowButton onClick={onNowClick} />
    </div>
  )
}
